export type ValidationTranslation = {
  atLeastOneRequired: string;
  charactersLimit: string;
  date: { maxCurrentDate: string; maxDate: string; minCurrentDate: string; notEarlierThen: string };
  email: string;
  general: { required: string; wrongFormat: string };
  iban: string;
  incorrectFileExtension: string;
  integerNumber: string;
  isNumber: string;
  length: string;
  max: string;
  maxLength: string;
  maxLengthOfMessage: string;
  maxStringLength: string;
  min: string;
  minLength: string;
  minNumber: string;
  minStringLength: string;
  mobile: string;
  nip: string;
  noResults: string;
  passwordMustMatch: string;
  passwordRequirements: string;
  pesel: string;
  phone: string;
  pinsMustMatch: string;
  rating: string;
  regon: string;
  required: string;
  stringLength: string;
  tooLargeFileSize: string;
};

export const validationTranslation: ValidationTranslation = {
  atLeastOneRequired: 'Przynajmniej jedno pole jest wymagane',
  charactersLimit: 'Maksymalna liczba znaków to {{noOfChars}}',
  date: {
    maxCurrentDate: 'Data nie może być w przyszłości',
    maxDate: 'Data nie może być późniejsza niż {{maxDate}}',
    minCurrentDate: 'Data nie może być w przeszłości',
    notEarlierThen: '{{to}} nie może być wcześniejsze niż {{from}}',
  },
  email: 'Adres e-mail jest nieprawidłowy',
  general: { required: 'To pole jest wymagane', wrongFormat: 'Nieprawidłowy format' },
  iban: 'Numer IBAN jest niepoprawny',
  incorrectFileExtension:
    'Nieprawidłowe rozszerzenie pliku. Obsługiwane rozszerzenia: {{correctExtensions}}',
  integerNumber: 'To pole musi być liczbą całkowitą',
  isNumber: 'To pole musi być liczbą',
  length: 'To pole musi mieć {{length}} znaków',
  max: 'Maksymalna wartość to {{howMany}}',
  maxLength: 'To pole może mieć maksymalnie {{max}} znaków',
  maxLengthOfMessage: 'Maksymalna długość wiadomości to {{max}} znaków',
  maxStringLength: 'Maksymalna długość tego pola to: {{max}}',
  min: 'Minimalna wartość to {{howMany}}',
  minLength: 'To pole musi mieć co najmniej {{min}} znaków',
  minNumber: 'Minimalna wartość dla tego pola to: {{minNumber}}',
  minStringLength: 'Minimalna długość dla tego pola to: {{min}}',
  mobile: 'Numer telefonu jest nieprawidłowy - dozwolone są tylko plus (+), myślniki (-) i cyfry',
  nip: 'Nieprawidłowy numer NIP',
  noResults: 'Brak wyników',
  passwordMustMatch: 'Hasła muszą być identyczne',
  passwordRequirements:
    'Hasło musi zawierać jedną cyfrę, jedną małą literę, jedną wielką literę i jeden znak specjalny. Długość hasła musi mieścić się w przedziale od 8 do 100 znaków.',
  pesel: 'Nieprawidłowy numer PESEL',
  phone: 'Numer telefonu jest nieprawidłowy (XXX-XXX-XXX)',
  pinsMustMatch: 'Piny muszą być identyczne',
  rating: 'Proszę wybrać ocenę',
  regon: 'Nieprawidłowy numer REGON',
  required: 'To pole jest wymagane',
  stringLength: 'To pole musi mieć {{length}} znaków',
  tooLargeFileSize: 'Rozmiar pliku jest za duży. Maksymalny rozmiar pliku to: {{maxFileSize}}',
};
